import { useLazyQuery, useMutation } from '@apollo/client';
import { UPDATE_ULTRA_PLAN_ROADMAP_DOCUMENT } from '../graphql/Mutations';
import { ULTRA_PLAN_ROADMAP_SIGNED_PUT_URL } from '../graphql/Queries';

const useUltraPlanRoadmapDocument = ({ userSubscriptionId, onSaved }) => {
  const [getSignedPutUrl] = useLazyQuery(ULTRA_PLAN_ROADMAP_SIGNED_PUT_URL, {
    fetchPolicy: 'network-only',
    onError() {},
  });

  const [updateUserSubscription] = useMutation(
    UPDATE_ULTRA_PLAN_ROADMAP_DOCUMENT,
    {
      onError() {},
    },
  );

  const getRoadmapSignedPutUrl = async (fileName) => {
    const response = await getSignedPutUrl({
      variables: {
        data: {
          fileName,
          userSubscriptionId,
        },
      },
    })?.catch(() => null);
    if (!response || response?.error) {
      throw new Error();
    }
    return response?.data?.getUltraPlanRoadMapSignedPutUrl;
  };

  const saveRoadmapDocument = async (uploadedFile) => {
    const response = await updateUserSubscription({
      variables: {
        data: {
          ultraPlanRoadMap: uploadedFile?.fileName,
        },
        where: {
          id: userSubscriptionId,
        },
      },
    });
    if (!response?.data) {
      throw new Error();
    }
    onSaved?.();
  };

  return { getRoadmapSignedPutUrl, saveRoadmapDocument };
};

export default useUltraPlanRoadmapDocument;
